import React from 'react';
import { useNavigate } from 'react-router-dom';
import peachjarLogo from '@/assets/logo.svg';
import digitalFlyerIllustration from '@/assets/digital_flyer.png';
import { useAnalytics } from '@/hooks/useAnalytics';
import { GenericTrackTypes } from '@/types/genericTrackTypes';
import { APP_ROUTES } from '@/config/constants';

import {
  BodyLarge,
  TitleLargeEmphasized,
  ButtonPrimaryLarge,
  ButtonOutlineLarge,
} from '@/design-system';
import styles from './Welcome.styles';

export const Welcome: React.FC = () => {
  const navigate = useNavigate();

  const { track } = useAnalytics();

  const trackId = 'welcome_page';

  const onSignUpClick = () => {
    track({
      action: GenericTrackTypes.BUTTON_PRESSED,
      category: `${trackId}:signup`,
      label: 'Sign Up',
    });
    navigate(APP_ROUTES.signUp);
  };

  const onLogInClick = () => {
    track({
      action: GenericTrackTypes.BUTTON_PRESSED,
      category: `${trackId}:loginIn`,
      label: 'Login In',
    });
    navigate(APP_ROUTES.login);
  };

  return (
    <main className={styles.container}>
      <header className={styles.header}>
        <div className={styles.logo}>
          <img
            src={peachjarLogo}
            alt="Peachjar Logo"
            width="120px"
            height="38px"
            data-testid="peachjarLogo"
          />
        </div>
        <img
          src={digitalFlyerIllustration}
          data-testid="digitalFlyer"
          alt="Digital Flyer Illustration"
          width="275.2px"
          height="198px"
        />
      </header>
      <TitleLargeEmphasized as="h1">Welcome to Peachjar!</TitleLargeEmphasized>
      <div className={styles.description}>
        <BodyLarge>
          We're here to help you stay connected with your child's school and community.
        </BodyLarge>
      </div>
      <div className={styles.footer}>
        <ButtonPrimaryLarge fullWidth onClick={onLogInClick}>
          Log In
        </ButtonPrimaryLarge>
        <ButtonOutlineLarge fullWidth onClick={onSignUpClick}>
          Sign Up
        </ButtonOutlineLarge>
      </div>
    </main>
  );
};

export default Welcome;
